import { useState } from 'react';
import { company, faqSection } from '../content/site';
import { Plus } from './Icons';
import { Reveal } from './Reveal';
import './Faqs.css';

export function Faqs() {
  const [openId, setOpenId] = useState<string | null>('sra-0');

  return (
    <section className="section" id="faqs">
      <div className="container">
        <Reveal>
          <div className="section-head section-head--wide">
            <p className="eyebrow">{faqSection.eyebrow}</p>
            <h2 className="section-title">{faqSection.title}</h2>
            <p className="section-lead">{faqSection.lead}</p>
          </div>
        </Reveal>

        <div className="faqs">
          {faqSection.groups.map((group) => (
            <Reveal key={group.id} className="faqs__group-reveal">
              <div className="faqs__group">
                <h3 className="faqs__group-title">{group.title}</h3>

                <div className="faqs__items">
                  {group.items.map((item, index) => {
                    const id = `${group.id}-${index}`;
                    const open = openId === id;

                    return (
                      <div
                        key={id}
                        className={`faq ${open ? 'is-open' : ''}`}
                      >
                        <h4 className="faq__heading">
                          <button
                            type="button"
                            className="faq__trigger"
                            aria-expanded={open}
                            aria-controls={`faq-answer-${id}`}
                            id={`faq-trigger-${id}`}
                            onClick={() => setOpenId(open ? null : id)}
                          >
                            <span className="faq__question">{item.q}</span>
                            <Plus className="faq__icon" width={20} height={20} />
                          </button>
                        </h4>
                        <div
                          className="faq__panel"
                          id={`faq-answer-${id}`}
                          role="region"
                          aria-labelledby={`faq-trigger-${id}`}
                          hidden={!open}
                        >
                          <p className="faq__answer">{item.a}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="faqs__footnote">
            Something not covered here? Ask us directly at{' '}
            <a href={`mailto:${company.email}`}>{company.email}</a> — a principal
            will answer, and nothing you send is shared outside {company.name}.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
